module.exports = __webpack_public_path__ + "7552e30e7535d5a7703b8785d686477e.MP3";